module.exports = __webpack_public_path__ + "media/app/assets/mailers/twitch-bb216e1a15cacf15c22c10001dfb4684.png";